//User Types
export const STUDENT_DC = 'StudentDC'
export const STUDENT_INPERSON = 'StudentInPerson'
export const TEACHER = 'Teacher'
export const TEACHER_DC = 'TeacherDC'

export const STUDENT_USER_TYPES = [STUDENT_INPERSON, STUDENT_DC]
export const TEACHER_USER_TYPES = [TEACHER, TEACHER_DC]
//User Levels
export const LEVELS = {
  1: 'meditator',
  2: 'sidha',
  3: 'teacher',
}

//Gender types
export const MALE = 'male'
export const FEMALE = 'female'
export const OTHER = 'other'

//Device Types
export const ANDROID = 'android'
export const IOS = 'ios'

//View Modes
export const VIEW = 'view'
export const EDIT = 'edit'

//Page Contexts
export const STUDENT_CREATE = 'student-create'
export const TEACHER_CREATE = 'teacher-create'
export const STUDENT_UPDATE = 'student-update'
export const TEACHER_UPDATE = 'teacher-update'
export const TRAINING_UPDATE = 'training-update'
export const TEACHER_CREATED = 'teacher-created'

//Radio Select Options
export const GENDER_OPTIONS = [
  { value: MALE, label: 'Male' },
  { value: FEMALE, label: 'Female' },
  { value: OTHER, label: 'Other' },
]
export const USER_TYPE_OPTIONS = [
  { value: STUDENT_INPERSON, label: 'In-Person' },
  { value: STUDENT_DC, label: 'Digital Course' },
]
export const PHONE_TYPE_OPTIONS = [
  { value: ANDROID, label: 'Android' },
  { value: IOS, label: 'iPhone' },
]

export const DC_STATUS_LABELS = {
  locked: 'Locked',
  progress: 'In Progress',
  unlocked: 'Unlocked',
  review: 'In Review',
  inactive: 'Inactive',
  deactivated: 'Disabled',
  disabled: 'Disabled',
  'completed-review': 'In Progress',
  reactivated: 'Reactivated',
  incomplete: 'Community',
  'not-done': 'Not Done',
  done: 'Done',
} as const

export const IP_STATUS_LABELS = {
  waiting: 'Waiting',
  invited: 'Invited',
} as const
export const TMATT_STATUS_LABELS = {
  waiting: 'Waiting',
  'pre-course': 'Pre-Course',
  'signature-pending': 'Signature Pending',
  completed: 'Completed',
  progress: 'In Progress',
  completedTmatt: 'Completed',
  expired: 'Expired',
  deactivated: 'Deactivated',
} as const
export const TMATT_STATUS_TYPES: any = {
  completed: 'Completed',
  progress: 'In Progress',
  'signature-pending': 'Signature pending',
  waiting: 'Waiting',
  'pre-course': 'Pre-course',
}
export const SHARED_STATUS_LABELS = {
  completed: 'Community',
} as const

export const STATUS_LABELS = {
  ...IP_STATUS_LABELS,
  ...DC_STATUS_LABELS,
  ...TMATT_STATUS_LABELS,
  ...SHARED_STATUS_LABELS,
  [STUDENT_DC]: 'Digital Course',
  [STUDENT_INPERSON]: 'In-Person',
  unknown: 'Unknown',
  teacher: 'Teacher',
  Teacher: 'Teacher',
  'no-app-access': 'No App Access',
} as const

export const ENROLLMENT_DATE = 'Enrollment date date'
export const EXPIRATION_DATE = 'Expiration date'
export const SORT_OPTIONS = [ENROLLMENT_DATE, EXPIRATION_DATE]

// LMS data
export const LMS_URL =
  'https://maharishi-foundation-international.moodlecloud.com/login/index.php'
